import { debounce } from 'lodash'
import React from 'react'
import Autosuggest from 'react-autosuggest'
import { toast } from 'react-toastify'
import { AccountInfoDto } from '../../../../definition'
import { asyncGetListCustomers } from '../../../../services'
import './customer-auto-suggestion.css'

function getSuggestionValue(suggestion: AccountInfoDto): string {
  return suggestion.suggestContactShow || ''
}

function renderSuggestion(suggestion: AccountInfoDto) {
  return <span>{suggestion.suggestContactShow}</span>
}

export interface CustomerAutosuggestProps {
  onSuggestionSelected: (customer: AccountInfoDto) => void
  onInputChange?: (newValue: string) => void
  value?: string
}

export interface CustomerAutosuggestState {
  value: string
  suggestions: AccountInfoDto[]
  isLoading: boolean
}

export class CustomerPhoneAutosuggest extends React.Component<CustomerAutosuggestProps, CustomerAutosuggestState> {
  constructor(props: CustomerAutosuggestProps) {
    super(props)

    this.state = {
      value: this.props.value || '',
      suggestions: [],
      isLoading: false
    }

    // Always delay the search in 0.3 second
    this.loadSuggestions = debounce(this.loadSuggestions, 300)
  }

  componentDidMount(): void {
    this.loadSuggestions('')
  }

  loadSuggestions(value: string) {
    // if loading then cancel new search
    if (this.state.isLoading) {
      return
    }

    this.setState({
      isLoading: true
    })

    asyncGetListCustomers({ search: value, limit: 20, offset: 0 })
      .then((list) => {
        const listSuggestions: AccountInfoDto[] = []
        list?.items.forEach((customer) => {
          const isResultFindBySubOnly = customer.profile?.subContacts?.find(
            (sub) => sub.contact.includes(value) && !customer.profile?.contact.includes(value)
          )
          if (isResultFindBySubOnly) {
            listSuggestions.push({
              ...customer,
              suggestContactShow: isResultFindBySubOnly.contact,
              subContactId: isResultFindBySubOnly.id
            })
          } else {
            listSuggestions.push({
              ...customer,
              suggestContactShow: customer.profile?.contact
            })
          }
        })
        this.setState({
          suggestions: listSuggestions || [],
          isLoading: false
        })
      })
      .catch((error) => {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      })
  }

  onChange = (_event: any, input: any) => {
    this.setState({
      value: input.newValue
    })
    this.props.onInputChange && this.props.onInputChange(input.newValue)
  }

  onSuggestionsFetchRequested = (input: any) => {
    this.loadSuggestions(input.value)
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    })
  }

  onSuggestionSelected = (_event: any, input: any) => {
    this.props.onSuggestionSelected(input.suggestion)
  }

  render() {
    const { value, suggestions } = this.state
    const inputProps = {
      placeholder: 'Type customer phone',
      value,
      onChange: this.onChange
    }

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionSelected={this.onSuggestionSelected}
        inputProps={inputProps}
      />
    )
  }
}
